import React from 'react'

import { BnblSteps } from 'components/OfferPage/BnblModal/utils'
import BnblOneRoomPackage from './BnblOneRoomPackage'
import BnblMultipleRoomPackage from './BnblMultipleRoomPackage'
import { connect } from 'react-redux'
import Group from 'components/utils/Group'

interface MappedProps {
  bnblModalPackages: App.BnblModal[];
}
interface Props {
  offer: App.Offer;
  setStep: (step: BnblSteps) => void;
}

function BnblHomeStep(props: Props & MappedProps) {
  const {
    offer,
    bnblModalPackages,
    setStep,
  } = props

  return <Group direction="vertical" gap={16}>
    {bnblModalPackages.length === 1 && (
      <BnblOneRoomPackage setStep={setStep} offer={offer} />
    )}
    {bnblModalPackages.length > 1 && (
      <BnblMultipleRoomPackage offer={offer} />
    )}
  </Group>
}

function mapStateToProps(state: App.State, ownProps: Props): MappedProps {
  return {
    bnblModalPackages: state.offer.bnblModal[ownProps.offer.id],
  }
}

export default connect(mapStateToProps)(BnblHomeStep)
